export default "__VITE_ASSET__4a611053__"